import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { Box, Button, Typography } from '@material-ui/core';
import Carousel from 'react-elastic-carousel';
import Grid from '@material-ui/core/Grid';
import { Stars } from '@material-ui/icons';

const useStyles = makeStyles({
  root: {
    maxWidth: 350,
    maxHeight: 400
  },
  media: {
    width: 310,
    height: 200,
    marginRight: 10
  },
  logo: {
    width: '100%'
  },
  subtitleBox: {
    height: 50,
    display: 'flex',
    alignItems: 'center'
  },
  logoBox: {
    height: 50,
    width: 50,
    display: 'flex',
    alignItems: 'center',
    marginBottom: 20
  }
});

const ReportCarousel = ({ tableData }) => {
  const classes = useStyles();
  console.log('tableData', tableData);

  const [showArrows, setShowArrows] = useState(true);
  const myArrow = ({ type, onClick, isEdge }) => {
    const pointer = type === 'PREV' ? '<' : '>';
    return (
      <Button onClick={onClick} disabled={isEdge} style={{ minWidth: '10px' }}>
        {pointer}
      </Button>
    );
  };

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2, itemsToScroll: 2 },
    { width: 768, itemsToShow: 4 },
    { width: 1200, itemsToShow: 4 }
  ];

  const handleResize = (current) => {
    if (current.itemsToShow === 1) {
      setShowArrows(false);
    } else {
      setShowArrows(true);
    }
  };

  return (
    <Carousel
      pagination={false}
      breakPoints={breakPoints}
      renderArrow={myArrow}
      onResize={handleResize}
      showArrows={true}
    >
      {tableData.map((hosp) => (
        <Card key={hosp.ID} className={classes.root}>
          <CardActionArea>
            <CardContent>
              <Grid container>
                <Grid
                  item
                  lg={4}
                  md={4}
                  xs={4}
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Box className={classes.logoBox}>
                    <img
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = "https://linkmedicine.com/wp-content/uploads/hosp_logos/sample.png";
                      }}
                      src={`https://linkmedicine.com/wp-content/uploads/hosp_logos/SQ_${hosp.Image}`}
                      className={classes.logo}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  lg={8}
                  md={8}
                  xs={8}
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Box className={classes.subtitleBox}>
                    <Typography style={{ fontSize: 14 }}>
                      {hosp.Name}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              <CardMedia
                className={classes.media}
                image={`https://linkmedicine.com/wp-content/uploads/hosp_imgs/${hosp.Image
                    ? hosp.Image.substring(0, hosp.Image.lastIndexOf('.'))
                    : 'Hospital'
                  }.JPG`}
                title="Contemplative Reptile"
              />
            </CardContent>
          </CardActionArea>
          <CardActions>
            {hosp.aiTop > 0 && <Stars color="primary" />}
            <Button size="small" color="primary">
              Score: {hosp.Score}
            </Button>
          </CardActions>
        </Card>
      ))}
    </Carousel>

    // <Carousel centerMode showIndicators={false} swipeable>

    // </Carousel>
  );
};

ReportCarousel.propTypes = {
  tableData: PropTypes.object.isRequired
};
export default ReportCarousel;



// WEBPACK FOOTER //
// ./src/components/ReportCarousel/ReportCarousel.js